export const ErrorType = {
  Email: 'Email',
  Username: 'Username',
  Password: 'Password',
  SignInPassword: 'SignInPassword',
  SignInUsername: 'SignInUsername',
  Comment: 'Comment',
  LocationZipCode: 'LocationZipCode',
  LocationCity: 'LocationCity',
  AccessDenied: 'AccessDenied',
  VIN: 'VIN',
  SoldAfterAuctionValue: 'SoldAfterAuctionValue',
}
